import produce from "immer";
import AddressesContent from "@Types/addresses";
import { CartState } from "../";

export interface SetSavedAddressesAction {
  addresses: AddressesContent;
  type: "setSavedAddresses";
}

export const setSavedAddresses = (state: CartState, action: SetSavedAddressesAction): CartState => {
  return produce(state, (draftState) => {
    if (action.addresses.billing) {
      draftState.addresses.billing = action.addresses.billing;
    }
    if (action.addresses.delivery) {
      draftState.addresses.delivery = action.addresses.delivery;
    }
  });
};
